import { domain } from 'modules/data';
import { useMemo } from 'react';

import { NetSuiteMatchingLine, NetSuiteMatchingLinesParams } from './useNetSuiteMatchingLines.types';

export const useNetSuiteMatchingLines = ({
    matchingLinesInfos,
    lineType,
    lineNumber,
    request,
}: NetSuiteMatchingLinesParams) => {
    const isPO = request.integrationCode === domain.IntegrationCode.NetSuitePO;

    const matchingLines = useMemo(
        () =>
            matchingLinesInfos.reduce<NetSuiteMatchingLine[]>((matchedLines, { line, ...info }) => {
                if (line && info.documentLineType === lineType && info.documentLineNumber === lineNumber) {
                    matchedLines.push({
                        ...line,
                        id: `${info.requestId}-${line.lineNumber}`,
                        name: info.friendlyName,
                        date: info.date,
                        totalAmount: info.totalAmount,
                        requestId: info.requestId,
                        taxCode: domain.schemas.mapReference(line.taxCode),
                        department: domain.schemas.mapReference(line.department),
                        class: domain.schemas.mapReference(line.class),
                        location: domain.schemas.mapReference(line.location),
                        customer: domain.schemas.mapReference(line.customer),
                        category: 'category' in line ? domain.schemas.mapReference(line.category) : null,
                        account: 'account' in line ? domain.schemas.mapReference(line.account) : null,
                        item: 'item' in line ? domain.schemas.mapReference(line.item) : null,
                        billRequestId: isPO ? info.requestId : request.id,
                        billLineNumber: isPO ? line.lineNumber : info.documentLineNumber,
                        billed: 'matchedQuantity' in line ? line.matchedQuantity : null,
                        isMatched: line.isMatched ?? false,
                        customFields: line?.customFields?.map((customField) => ({
                            ...customField,
                            valueRef: customField.valueRef
                                ? { id: customField.valueRef.id, text: customField.valueRef.name || '' }
                                : null,
                            valueRefs: customField.valueRefs
                                ? customField.valueRefs.map((valueRef) => ({
                                      id: valueRef.id,
                                      text: valueRef.name || '',
                                  }))
                                : null,
                        })),
                    });
                }

                return matchedLines;
            }, []),
        [matchingLinesInfos, lineType, lineNumber, request.id, isPO]
    );

    return matchingLines;
};
